__turbopack_context__.v({
  "alert": "auth-module__cni4Dq__alert",
  "alertError": "auth-module__cni4Dq__alertError",
  "alertInfo": "auth-module__cni4Dq__alertInfo",
  "alertSuccess": "auth-module__cni4Dq__alertSuccess",
  "captcha": "auth-module__cni4Dq__captcha",
  "captchaError": "auth-module__cni4Dq__captchaError",
  "cardTitle": "auth-module__cni4Dq__cardTitle",
  "checkbox": "auth-module__cni4Dq__checkbox",
  "external": "auth-module__cni4Dq__external",
  "facts": "auth-module__cni4Dq__facts",
  "field": "auth-module__cni4Dq__field",
  "fieldError": "auth-module__cni4Dq__fieldError",
  "footerLinks": "auth-module__cni4Dq__footerLinks",
  "form": "auth-module__cni4Dq__form",
  "grid2": "auth-module__cni4Dq__grid2",
  "hint": "auth-module__cni4Dq__hint",
  "honeypot": "auth-module__cni4Dq__honeypot",
  "idp": "auth-module__cni4Dq__idp",
  "idpDomain": "auth-module__cni4Dq__idpDomain",
  "idpHeading": "auth-module__cni4Dq__idpHeading",
  "idpList": "auth-module__cni4Dq__idpList",
  "idpName": "auth-module__cni4Dq__idpName",
  "idpSection": "auth-module__cni4Dq__idpSection",
  "input": "auth-module__cni4Dq__input",
  "label": "auth-module__cni4Dq__label",
  "legend": "auth-module__cni4Dq__legend",
  "optional": "auth-module__cni4Dq__optional",
  "panel": "auth-module__cni4Dq__panel",
  "passwordWrap": "auth-module__cni4Dq__passwordWrap",
  "photo": "auth-module__cni4Dq__photo",
  "photoCaption": "auth-module__cni4Dq__photoCaption",
  "photoInstitution": "auth-module__cni4Dq__photoInstitution",
  "photoText": "auth-module__cni4Dq__photoText",
  "photoTitle": "auth-module__cni4Dq__photoTitle",
  "profile": "auth-module__cni4Dq__profile",
  "profileGrid": "auth-module__cni4Dq__profileGrid",
  "profileHeader": "auth-module__cni4Dq__profileHeader",
  "provider": "auth-module__cni4Dq__provider",
  "providerHint": "auth-module__cni4Dq__providerHint",
  "reveal": "auth-module__cni4Dq__reveal",
  "row": "auth-module__cni4Dq__row",
  "searchRow": "auth-module__cni4Dq__searchRow",
  "section": "auth-module__cni4Dq__section",
  "separator": "auth-module__cni4Dq__separator",
  "shell": "auth-module__cni4Dq__shell",
  "smallPrint": "auth-module__cni4Dq__smallPrint",
  "spin": "auth-module__cni4Dq__spin",
  "spinner": "auth-module__cni4Dq__spinner",
  "stack": "auth-module__cni4Dq__stack",
  "submit": "auth-module__cni4Dq__submit",
  "subtitle": "auth-module__cni4Dq__subtitle",
  "title": "auth-module__cni4Dq__title",
  "universityBadge": "auth-module__cni4Dq__universityBadge",
  "wide": "auth-module__cni4Dq__wide",
});
